export default __webpack_public_path__ + "static/media/home-1.665dd31d.png";